// src/services/storageInit.js
// Selects the storage backend based on environment variables.
//
// When REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY are set,
// the app uses SupabaseBackend (data persists in Supabase rms_config table).
// Otherwise, LocalStorageBackend remains active (default, for local dev).
//
// Call initStorage() once at app startup — before any service reads.
// It is idempotent (safe to call multiple times).

import storage from './StorageAdapter';
import SupabaseBackend from './SupabaseBackend';

let initialized = false;

export function initStorage() {
  if (initialized) return;
  initialized = true;

  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

  if (supabaseUrl && supabaseKey) {
    const backend = new SupabaseBackend(supabaseUrl, supabaseKey);
    storage.setBackend(backend);
    // eslint-disable-next-line no-console
    console.info('[storageInit] SupabaseBackend active —', supabaseUrl);
  }
  // else: LocalStorageBackend is the default — no action needed
}

// Keys that should be hydrated immediately after backend selection.
// Used by App.js to pre-populate the cache before the first render.
// These are the keys required at startup / login time — module data keys
// (e.g. bwra_risks, georisk_countries) are loaded on-demand by each service.
export const CRITICAL_KEYS = [
  'rms_session',        // SessionService — active session token + user info
  'rms_last_activity',  // SessionService — idle-timeout tracking
  'rms_settings',       // SettingsService — theme, language, enabled modules
  'rms_entities',       // EntityService — list of entities
  'rms_active_entity',  // EntityService — currently selected entity
  'rms_licenses',       // LicenseService — module access per entity
  'rms_auth_config',    // AuthService — authentication provider config
  'admin_users',        // UserService — local user accounts + roles
];
